import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataServiceConfig, HttpUrlGenerator } from '@ngrx/data';
import { Store } from '@ngrx/store';
import { LoggingService } from '../../shared/services/logging';
import { EfaactDataService } from '../efaact.data-service';
import { Toast } from './toast.model';

export const entityName = 'Toaster';
@Injectable({ providedIn: 'root' })
export class ToasterDataService extends EfaactDataService<Toast> {
    mapItems(item: Toast): Toast {
        throw new Error('Method not implemented.');
    }

    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store
    ) {
        super(http, httpUrlGenerator, entityName, log, config, store);
    }
}
